import classNames from 'classnames';
import { ReactNode } from 'react';
import { useBreakpoint } from '~/hooks/useBreakpoint';

type BubbleProps = {
  children: ReactNode;
};

export const Bubble = ({ children }: BubbleProps) => {
  const { isMobile } = useBreakpoint();

  return (
    <div
      className={classNames(
        'flex flex-col leading-5 text-[#002727]',
        isMobile ? 'gap-2' : 'gap-[13px]'
      )}
    >
      {children}
    </div>
  );
};
